import { FormField } from '@cp/ds/src/components/form';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { catalogOptionCoreApi } from '@cp/entities/catalogOption';
import { CheckboxGroupItemConfig } from '@cp/ds/src/components/form/components/field/checkboxGroup/model';
import { useTheme } from '@cp/ds/src/hooks';
import { CareerId } from '@common/const/catalog/career';
import { CheckableAdvantage, CheckableAdvantageTokens } from '@cp/entities/advantage';
import { FormFieldName } from '../../model/form';

const obj2arr = (obj: Record<string, boolean>): string[] => {
  return Object.keys(obj).filter((key) => obj[key]);
};
const arr2obj = (arr: number[] | null) => {
  if (!arr) {
    return;
  }
  return arr.reduce((acc, v) => {
    acc[v] = true;
    return acc;
  }, {});
};

export const OptionsField: React.FC<{ careerId: CareerId }> = ({ careerId }) => {
  const theme = useTheme();
  const { data: allOptions } = catalogOptionCoreApi.endpoints.getOptions.useQuery({ careerId, active: true });

  const optionItems: CheckboxGroupItemConfig<number>[] = allOptions
    ? allOptions.items.map(
        (option): CheckboxGroupItemConfig<number> => ({
          value: option.id,
          label: option.translation.title,
          icon: option.icon?.value,
        }),
      )
    : [];

  return (
    <FormField
      checkboxComponent={CheckableAdvantage}
      containerProps={{
        rowSpacing: 1.5,
        sx: {
          [CheckableAdvantageTokens.colorBackground]: { md: theme.palette['gray ultra light'] },
        },
      }}
      itemSx={{ width: 1 }}
      items={optionItems}
      name={FormFieldName.Options}
      transform={{
        in: (v) => {
          return obj2arr(v as Record<string, boolean>).map(Number);
        },
        out: (v) => {
          return arr2obj(v as number[] | null);
        },
      }}
      type="checkboxGroup"
    />
  );
};
